const getters = {
    user: ({ user }) => {
      return user;
    }
  };
  
export default getters;
  